import isWeb from './isWeb';
// const electron = isWeb ? null : window.require('electron');
// const desktopCapturer = electron?.desktopCapturer;

export default async (callBack: (screen: string) => void) => {
  // if (!!desktopCapturer) {
  //   desktopCapturer
  //     .getSources({
  //       types: ['screen'],
  //       thumbnailSize: {
  //         height: 720,
  //         width: 1000,
  //       },
  //     })
  //     .then((sources: { thumbnail: any }[]) => {
  //       const image = sources[0].thumbnail
  //         .resize({ width: window.innerWidth - 100, height: window.innerHeight - 100 })
  //         .toDataURL();
  //       callBack(image);
  //     });
  // } else {
  //   console.log('no desktopCapturer');
  // }
};
